type Props = {
  title: string;
  value: string | number;
};

export const SingleMetric = ({ title, value }: Props) => {
  return (
    <div className="rounded-8 border border-[var(--media-kit-background-alpha)] bg-[var(--media-kit-background-primary)] px-6 py-4">
      <h3
        className="truncate text-nowrap text-16 font-500 leading-24 text-[var(--media-kit-text-subtle)]"
        title={title}
      >
        {title}
      </h3>
      <p className="text-32 font-500 leading-[2.5rem] text-[var(--media-kit-text-base)]">
        {value}
      </p>
    </div>
  );
};
